export default __webpack_public_path__ + "static/21-172cda72896769d7cde0da6fcd9a3465.png";